import React from 'react'

const TitleAndLinks = ({title, links}) => {
  return (
    <div className="App-title-and-links" >
      { title && links && links.length > 0 && <h3>{title}</h3> }
      { title && links && links.length > 0 && links.map(l => <a href={l.URL} className="App-external-link" target="_blank" rel="noopener noreferrer" key={l.id}>{l.text}</a>) }
    </div>
  )
}

export default TitleAndLinks